export var LAYER_WIDTH = 30;
export var SCROLLBAR_MIN_WIDTH = 14;
export var SCROLLBAR_WIDTH = 10;
export var CELL_PADDING_HEIGHT = 26;
export var RESIZE_MIN_WIDTH = 20;
export var SORT_TYPE = {
  DESC: 'desc',
  ASC: 'asc'
};